import { render, staticRenderFns } from "./_tabResults.vue?vue&type=template&id=4d8d487f&scoped=true&"
import script from "./_tabResults.vue?vue&type=script&lang=js&"
export * from "./_tabResults.vue?vue&type=script&lang=js&"
import style0 from "./_tabResults.vue?vue&type=style&index=0&id=4d8d487f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d487f",
  null
  
)

export default component.exports